import { fbt } from 'fbtee'
import { UserAvatar } from '../../components/UserAvatar'
import type { UserProfile } from '../../types'

// Shown on EventPage when arriving via a friend invite (?friend=<uid>): makes it
// clear the highlighted picks belong to that person, not the viewer.
export function FriendScopeBanner({ profile }: { profile: UserProfile | undefined }) {
  const name =
    profile?.displayName?.trim() || fbt('this friend', 'Fallback name in the friend-picks banner')
  return (
    <div className="flex items-center gap-2.5 rounded-xl bg-card ring-1 ring-foreground/10 px-3 py-2">
      <UserAvatar profile={profile} />
      <p className="text-sm">
        <fbt desc="Banner explaining the highlighted interests belong to a specific friend">
          Showing <fbt:param name="name">{name}</fbt:param>'s picks
        </fbt>
      </p>
    </div>
  )
}
